import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('Description', (theme) => ({
  root: {
    fontSize: theme.typography.fontSizePt625Rem,
    fontWeight: theme.typography.fontWeightExtraBold,
  },
}));

// DO NOT USE THIS COMPONENT IN AN OVERRIDE WITHOUT ENSURING IT IS RECEIVING RICHTEXT - for example, .override({ hint: 'richtext', ... }, { _component: () => Description })
export function Description({ value }) {
  const classes = useStyles();
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: value }} className={classes.root} />;
}

Description.defaultProps = {
};

Description.propTypes = {
  value: PropTypes.string.isRequired,
};
